import { Helmet } from 'react-helmet-async'
import PrivacyPolicyView from '../views/PrivacyPolicy'
import { useLanguage } from '../i18n/LanguageContext'

const PrivacyPolicyPage = () => {
  const { t } = useLanguage()

  return (
    <>
      <Helmet>
        <title>{t('seo.privacyTitle')}</title>
        <meta name="description" content={t('seo.privacyDescription')} />
      </Helmet>
      <PrivacyPolicyView />
    </>
  )
}

export default PrivacyPolicyPage
